function invoice(state = [], action) {
  switch (action.type) {
    case 'GET_INVOICE_LIST_SUCCESS':
      return action.payload
    default:
      return state
  }
}

export default invoice



// WEBPACK FOOTER //
// ./routes/app/routes/invoice/reducer/index.js